import { Injectable } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';

@Injectable({
  providedIn: 'root'
})
export class CustomDateFnsAdapter extends DateFnsAdapter {
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const dayNames = super.getDayOfWeekNames(style);
    return dayNames.map((day) => day.charAt(0).toUpperCase() + day.slice(1));
  }
}
